import { render, staticRenderFns } from "./BCardCode.vue?vue&type=template&id=5cff0742&scoped=true&"
import script from "./BCardCode.vue?vue&type=script&lang=js&"
export * from "./BCardCode.vue?vue&type=script&lang=js&"
import style0 from "./BCardCode.vue?vue&type=style&index=0&id=5cff0742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cff0742",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cff0742')) {
      api.createRecord('5cff0742', component.options)
    } else {
      api.reload('5cff0742', component.options)
    }
    module.hot.accept("./BCardCode.vue?vue&type=template&id=5cff0742&scoped=true&", function () {
      api.rerender('5cff0742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/components/b-card-code/BCardCode.vue"
export default component.exports